import { Link } from '@shopify/hydrogen'
import React from 'react'
import ImageVideo from '~/components/common/image-video/image-video.client'
import { PreviousDropsBlock } from '~/types/block-types'
import classes from './BlockPreviousDrop.module.scss'
import classNames from 'classnames'

interface BlockPreviousDropsProps {
  data: PreviousDropsBlock[]
}

const BlockPreviousDrops: React.FC<BlockPreviousDropsProps> = ({
  data,
}) => {
  const containerWrapper = classNames({
    [classes.FourPreviousDropsContainer]: data.length === 4,
    [classes.ThreePreviousDropsContainer]: data.length === 3,
    [classes.Container]: data.length < 3,
  })
  return (
    <div className={containerWrapper}>
      {data.map((drop, idx) => {
        const isVideo = drop.content?._type !== 'imageWithLink' && drop.content?._type !== 'videoUrl'
        const isVideoUrl = drop.content?._type !== 'videoAnimation' && drop.content?._type !== 'imageWithLink'
        const linkHref = drop.link?.slug || '/'
        return (
          // eslint-disable-next-line react/no-array-index-key
          <Link key={`${idx}-${drop.title}`} to={linkHref} className={classes.PreviousDrop} reloadDocument={true}>
            <div className={classes.OverlayShader}></div>
            
            {drop.content && <div className={classes.ImageWrapperOuter}><ImageVideo content={drop.content} isVideo={isVideo} isVideoUrl={isVideoUrl} /></div>} 
            { drop.link?.title && <div className={classes.ReadMoreBtn}><span>{drop.link?.title || 'READ MORE'}</span></div>}
            <div className={classes.TextContainer}>
              <h5>{drop.release}</h5>
              <h3>{drop.title}</h3>
              <p>{drop.subtitle}</p>
            </div>
          </Link>
        )
      })}
    </div>
  )
}

export default BlockPreviousDrops
